import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API = `${process.env.VUE_APP_API_URL}crm/leads/dashboard`;

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export default {
  get(params = {}) {
    return axios.get(API, { params, headers: buildHeaders() });
  },

  async exportPdf(params = {}) {
    const res = await axios.get(`${API}/export/pdf`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });

    const cd = res.headers["content-disposition"] || "";
    const match = cd.match(/filename="?([^"]+)"?/);
    const filename = match?.[1] || "leads-dashboard.pdf";

    downloadBlob(res.data, filename);
  },

  async exportExcel(params = {}) {
    const res = await axios.get(`${API}/export/excel`, {
      params,
      headers: buildHeaders(),
      responseType: "blob",
    });

    const cd = res.headers["content-disposition"] || "";
    const match = cd.match(/filename="?([^"]+)"?/);
    const filename = match?.[1] || "leads-dashboard.xlsx";

    downloadBlob(res.data, filename);
  },
};
